import _copy from "copy-to-clipboard";

export default function copy(value: string): boolean {
  return _copy(value, { format: "text/plain" });
}
